module.exports = __webpack_public_path__ + "img/Gen3-Outdoor.5c4cb8e7.svg";